<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
  >
    <v-card>
      <v-card-text class="container">
        <div class="offer">
          <div class="offer_nds">{{ $t('Цена с НДС:') }}<span>{{ formatStartPrice(offerPriceNds) }} $</span>
          </div>
          <v-chip class="offer_rate">
            {{ application.nds.rate !== null ? `${parseFloat(application.nds.rate)} %` : 'Без НДС' }}
          </v-chip>
        </div>
        <div class="offer_withNds">{{ $t('Цена без НДС:') }}<span>{{ formatStartPrice(offerPrice) }} $</span>
        </div>
        <div class="amount">{{ $t('Сумма НДС:') }}<span>
            {{ application.nds.rate !== null ? `${formatStartPrice(offerPriceNds - offerPrice)} $` : '-' }}
          </span>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatStartPrice } from '@/filters';
import { useApplicationCalculator } from '@/lib/application';

export default {
  name: 'NdsDlg',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    application: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      dialog: this.isOpen,
      formatStartPrice,
    }
  },
  computed: {
    offerPrice() {
      const calculator = useApplicationCalculator(
        this.application,
        this.application.positions ?? [],
        this.application.nds.rate,
      );
      return calculator.getChosenCost();
    },
    offerPriceNds() {
      if (this.application.offerPriceWithNds) {
        return this.application.offerPriceWithNds;
      }
      const calculator = useApplicationCalculator(
        this.application,
        this.application.positions ?? [],
        this.application.nds.rate,
      );
      return calculator.getChosenCostNds();
    },
  },
  watch: {
    isOpen(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit('update:isOpen', val);
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  gap: 2px;

  font-family: 'Manrope';
  font-size: 16px;
  font-weight: 500;
}

.offer {
  display: flex;
  justify-content: space-between;

  &_nds span, &_withNds span {
    font-weight: 400;
  }

  &_rate {
    max-height: 24px;
    background-color: rgb(var(--pink-bg-color));
    font-size: 14px;
  }
}

.amount {
  color:  rgb(var(--grey-font-color));

  &span {
    font-weight: 400;
  }
}
</style>
